
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Arches Icons","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 820.14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Nook Head Group","fill":"#e0dbc8"}},[_c('ellipse',{attrs:{"data-name":"Nook Ear Right","cx":"868.49","cy":"265.28","rx":"116.35","ry":"137.96","transform":"rotate(-45 759.94 220.322)"}}),_c('ellipse',{attrs:{"data-name":"Nook Ear Left","cx":"309.58","cy":"222.5","rx":"142.84","ry":"120.47","transform":"rotate(-36.16 171.87 177.541)"}}),_c('path',{attrs:{"data-name":"Nook Head","d":"M573.6 145.4c-205.73 0-374.77 148.18-374.77 350-49.36 17.4-123.48-1.11-169.42-16.25-17.86-5.88-34.65 11.58-27.87 29.13 36.89 95.59 165.32 311.86 572.06 311.86 223.16 0 372.52-126.68 372.52-337.37 0-186.33-166.78-337.37-372.52-337.37z"}})])])
          )
        }
      }
    